<template>
  <b-input-group :prepend="prepend">
    <b-form-input
      class="text-right"
      :value="rawValue"
      :disabled="disabled"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      @beforeinput="onBeforeInputHandler"
    />
  </b-input-group>
</template>

<script>
export default {
  name: 'VatCurrencyInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prepend: {
      type: String,
      default: '',
    },
    onBeforeInput: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      rawValue: this.formatNumber(this.value), // giữ dạng text ban đầu
      isFocused: false,
    };
  },
  watch: {
    value(newVal) {
      if (!this.isFocused) {
        this.rawValue = this.formatNumber(newVal);
      }
    },
  },
  methods: {
    formatNumber(val) {
      if (typeof val !== 'number') return '';
      if (val < 0) {
        return `(${Math.abs(val).toLocaleString('vi-VN')})`;
      }
      return val.toLocaleString('vi-VN');
    },
    parseCurrency(str) {
      // Nếu nhập dạng (1000) thì hiểu là -1000
      const isNegative = /^\(.*\)$/.test(str);
      let cleaned = str.toString().replace(/[().,]/g, '');
      let num = Number(cleaned.trim()) || 0;
      if (isNegative) num = -Math.abs(num);
      return num;
    },
    onInput(value) {
      this.rawValue = value;
      const parsed = this.parseCurrency(value);
      this.$emit('input', parsed);
    },
    onFocus() {
      this.isFocused = true;
    },
    onBlur(event) {
      this.isFocused = false;
      const parsed = this.parseCurrency(this.rawValue);
      this.rawValue = this.formatNumber(parsed);
      this.$emit('input', parsed);
    },
    onBeforeInputHandler(event) {
      const char = event.data;
      if (!char || typeof char !== 'string') return;

      const allowed = /[0-9.,]/;

      if (!allowed.test(char)) {
        event.preventDefault();
        return;
      }
      if (typeof this.onBeforeInput === 'function') {
        this.onBeforeInput(event);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/value-added-tax/vat-return/vat-return-table/vat-currency-input.vue